export default {
  intro: {
    default: 'Indtast oplysningerne for den person, der underskriver kontrakten.',
    gbr: 'Indtast oplysningerne for den partner, der underskriver kontrakten.',
    gmbh: 'Indtast oplysningerne for ejeren eller direktøren, der underskriver kontrakten.',
  },
  sections: {
    home_address: 'Hjemmeadresse',
    home_address_help: 'Hvor denne person bor, ikke restaurantens adresse.',
  },
  form: {
    owner_first_name: {
      label: 'Fornavn',
      placeholder: 'Indtast fornavn',
    },
    owner_last_name: {
      label: 'Efternavn',
      placeholder: 'Indtast efternavn',
    },
    owner_dob: {
      label: 'Fødselsdato',
      placeholder: 'Dato',
    },
    owner_phone_number: {
      label: 'Telefon',
    },
    owner_email: {
      label: 'E-mail',
      placeholder: 'Indtast e-mail',
      help: 'Denne kan være anderledes end den e-mail, du logger ind med.',
    },
    owner_id_number: {
      label: 'ID-nummer (f.eks. CPR-nummer i Danmark)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Tilbage',
    next: 'Næste',
  },
};
